module.exports = __webpack_public_path__ + "img/products_bg.9d7b9aad.png";